import { render, staticRenderFns } from "./liquor.vue?vue&type=template&id=bc96eb24&scoped=true"
import script from "./liquor.vue?vue&type=script&lang=js"
export * from "./liquor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc96eb24",
  null
  
)

export default component.exports